import type { ErrorTranslations } from "./utils";

export default {
  not_found: {
    EN: "Meeting not found",
    RO: "Ședința nu a fost găsită",
  },
  empty_projects: {
    EN: "The meeting must have at least one project",
    RO: "Ședința trebuie să aibă cel puțin un proiect",
  },
  public_servant_profile_not_found: {
    EN: "Public servant profile not found",
    RO: "Profilul funcționarului public nu a fost găsit",
  },
  already_in_progress: {
    EN: "There is already a meeting in progress",
    RO: "Există deja o ședință în desfășurare",
  },
  commission_member_already_exists: {
    EN: "Commission member already exists",
    RO: "Membrul comisiei există deja",
  },
  project_already_mapped: {
    EN: "Project already mapped",
    RO: "Proiectul este deja mapat",
  },
  commission_project_already_exists: {
    EN: "Commission is already mapped to the project",
    RO: "Comisia este deja mapată la proiect",
  },
} satisfies ErrorTranslations;
